import { motion } from "@smartsheet/design-tokens";
import { themed } from "@smartsheet/sds-theme-internal";
var motionTheme = themed({
  "lodestar-light": "",
  "ursa-light": "all ".concat(motion.animation.default)
});
export var getButtonMotion = function getButtonMotion(_ref) {
  var themeMode = _ref.themeMode;
  return motionTheme(themeMode);
};
//# sourceMappingURL=getButtonMotion.js.map